@if (!conversations) {
  <div class="fh appear_anim_1">
    <app-empty-state
      [isLoading]="true"
      [message]="'Searching...'"
      [stroke]="1"
      [diameter]="40"
    ></app-empty-state>
  </div>
}
@if (conversations) {
  <div class="list">
    <!-- No Result -->
    @if (!conversations.length) {
      <div class="no-results">
        <div class="content">
          <img
            class="appear_anim_1"
            src="../../../assets/search-conversation.svg"
            alt=""
          />
          <div class="appear_anim_2 celo-text-18 celo-bold-500">
            No results found
          </div>
        </div>
      </div>
    }
    <!-- Chats -->
    @if (chats.length) {
      <div class="appear_anim_1">
        <div class="title appear_anim_1">Chats</div>
        <app-conversation-results-group
          (muteStatus)="muteStatusChange($event)"
          (conversation)="onConversationSelected($event)"
          [conversations]="chats"
          [userAccount]="userAccount"
          [inConversationList]="true"
          [hideUnreadCount]="true"
          [isSelectionList]="isSelectionList"
          [selectedConversationId]="selectedConversationId"
        ></app-conversation-results-group>
      </div>
    }
    <!-- Groups -->
    @if (groups.length) {
      <div class="appear_anim_2">
        <div class="title appear_anim_1">Groups</div>
        <app-conversation-results-group
          (muteStatus)="muteStatusChange($event)"
          (conversation)="onConversationSelected($event)"
          [conversations]="groups"
          [userAccount]="userAccount"
          [inConversationList]="true"
          [hideUnreadCount]="true"
          [hideLastMessage]="true"
          [showParticipants]="true"
          [isSelectionList]="isSelectionList"
          [selectedConversationId]="selectedConversationId"
        ></app-conversation-results-group>
      </div>
    }
    <!-- Cases -->
    @if (cases.length) {
      <div class="appear_anim_3">
        <div class="title appear_anim_1">Cases</div>
        <app-conversation-results-group
          (muteStatus)="muteStatusChange($event)"
          (conversation)="onConversationSelected($event)"
          [conversations]="cases"
          [userAccount]="userAccount"
          [inConversationList]="true"
          [hideUnreadCount]="true"
          [hideLastMessage]="true"
          [showParticipants]="true"
          [isSelectionList]="isSelectionList"
          [selectedConversationId]="selectedConversationId"
        ></app-conversation-results-group>
      </div>
    }
    <!-- Archived -->
    @if (archived.length) {
      <div class="appear_anim_4">
        <div class="title appear_anim_1">Archived</div>
        <app-conversation-results-group
          (muteStatus)="muteStatusChange($event)"
          (conversation)="onConversationSelected($event)"
          [conversations]="archived"
          [userAccount]="userAccount"
          [inConversationList]="true"
          [hideUnreadCount]="true"
          [hideLastMessage]="conversation.type !== 'Chat'"
          [showParticipants]="conversation.type !== 'Chat'"
          [hideArchiveOption]="true"
          [isSelectionList]="isSelectionList"
          [selectedConversationId]="selectedConversationId"
        ></app-conversation-results-group>
      </div>
    }
    <!-- Load more -->
    @if (canLoadMore) {
      <button mat-button (click)="loadMore.emit()">Load More</button>
    }
  </div>
}
